// Imported gifs/images
import employeeTrackerGif from "../../assets/employee-tracker.gif";
import artHouseGif from "../../assets/arthouse-demo.gif";
import socialNetworkGif from "../../assets/social-network-api.gif";
import jsQuizGif from "../../assets/quiz-demo.gif";
import weatherDashboardGif from "../../assets/weather-dashboard-demo.gif";
import textEditorGif from "../../assets/text-editor-demo.gif";
import planItGif from "../../assets/plan-it-demo.gif";
import habitualGif from "../../assets/habitual-demo.gif";
import BookSearchGif from "../../assets/MERN-demo.gif"

const ProjectsArray = [
    {
      id: 1,
      name: "Employee Tracker",
      gitHubLink: "https://github.com/Raimeeab/Employee-Tracker",
      gif: employeeTrackerGif,
      projectLink:
        "https://drive.google.com/file/d/1f9POlZZEaAbdJOCRE920kQa88Ex8XPc2/view?usp=sharing",
    },
    {
      id: 2,
      name: "Social Network API",
      gitHubLink: "https://github.com/Raimeeab/social-network-api",
      gif: socialNetworkGif,
      projectLink:
        "https://drive.google.com/file/d/18mYEfZXHPbrh7vYTeFhbrXswXNRSFKJ1/view?usp=sharing",
    },
    {
      id: 3,
      name: "ArtHouse Project",
      gitHubLink: "https://github.com/Raimeeab/arthouse-project",
      gif: artHouseGif,
      projectLink: "https://raimeeab.github.io/arthouse-project/",
    },
    {
      id: 4,
      name: "JavaScript Quiz", 
      gitHubLink: "https://github.com/Raimeeab/code-quiz",
      gif: jsQuizGif, 
      projectLink: "https://raimeeab.github.io/code-quiz/"
    }, 
    {
      id: 5, 
      name: "Weather Dashboard", 
      gitHubLink: "https://github.com/Raimeeab/weather-dashboard", 
      gif: weatherDashboardGif, 
      projectLink: "https://raimeeab.github.io/weather-dashboard/"
    }, 
    {
      id: 6, 
      name: "Text Editor", 
      gitHubLink: "https://github.com/Raimeeab/text-editor",
      gif: textEditorGif, 
      projectLink: "https://peaceful-hamlet-70308.herokuapp.com/"
    }, 
    {
      id: 7, 
      name: "Plan It Project",
      gitHubLink: "https://github.com/Raimeeab/Planit", 
      gif: planItGif, 
      projectLink: "https://planit-events.herokuapp.com/"
    },
    {
      id: 8, 
      name: "Habitual", 
      gitHubLink: "https://github.com/Raimeeab/habitual", 
      gif: habitualGif, 
      projectLink: "https://habitual-ra.herokuapp.com/"
    }, 
    {
      id: 9, 
      name: "Google Book Search Engine", 
      gitHubLink: "https://github.com/Raimeeab/find-a-book", 
      gif: BookSearchGif, 
      projectLink: "https://murmuring-cliffs-97831.herokuapp.com/"
    }
  ];

  export default ProjectsArray; 